import { render, staticRenderFns } from "./messageNotification.vue?vue&type=template&id=17d784e8&scoped=true&"
import script from "./messageNotification.vue?vue&type=script&lang=js&"
export * from "./messageNotification.vue?vue&type=script&lang=js&"
import style0 from "./messageNotification.vue?vue&type=style&index=0&id=17d784e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d784e8",
  null
  
)

export default component.exports